import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-ion-common-data-list',
  templateUrl: './data-list.component.html',
  styleUrls: ['./data-list.component.scss'],
})
export class DataListComponent {

  @Input() idLink: string;
  @Input() labelTitle: string;
  @Input() labelStyle: string;
  @Input() ariaLevel = 2;
  @Input() linkSubtitle: string;
  @Input() linkSubtitleAriaLabel?: string;
  @Input() textEditFalse: string;
  @Input() itens: [];
  @Output() editClick = new EventEmitter();

  public edit(event: any, label: any) {
    event.preventDefault();
    this.editClick.emit(label);
  }
}
